export default __webpack_public_path__ + "static/media/workshop4.578b2134.jpg";